import React from 'react';
import Filter, { FilterModal, FilterSection } from './Filter';
import CheckboxFilterByType from './FilterComponents/CheckboxFilterByType';

import styles from '../search.scss';

const EventTypeFilter = (props) => {
    const { filters, filterModal, handleFilterClick, closeModals, filterInputs, searchTypes, handleFilterSubmit, clearFilters, handleFilterUpdate, mobileOnly, desktopOnly, 'data-testid': dataTestId } = props;
    const pickleballEventsFilters = ['tournament', 'camp', 'clinic', 'match_play', 'group_play'];
    const pickleballTypes = { eventTypes: [] };
    pickleballTypes.eventTypes = searchTypes.eventTypes.filter((eventType) => pickleballEventsFilters.includes(eventType.value));
    const finalSearchTypes = !!filterInputs?.sportTypes?.pickleball && !filterInputs?.sportTypes?.tennis ? pickleballTypes : searchTypes;
return (
    <div className={styles.filterWrapper}>
        <Filter
            filterName={'eventType'}
            handleFilterClick={handleFilterClick}
            isActive={(filters && filters.eventTypes && Object.values(filters.eventTypes).indexOf(true) > -1) || filterModal === 'eventType'}
            mobileOnly={mobileOnly}
            desktopOnly={desktopOnly}
            data-testid={dataTestId}
        >
                Type
        </Filter>
        {filterModal === 'eventType' && (
        <FilterModal
            title={'Type'}
            handleFilterSubmit={handleFilterSubmit}
            onCloseClick={closeModals}
            clearFilters={() => clearFilters('eventType')}
            data-testid={dataTestId}
        >
            <FilterSection>
                <CheckboxFilterByType
                    searchTypes={finalSearchTypes}
                    searchTypesPropName={`eventTypes`}
                    filterInputs={filterInputs}
                    filtersPropName={`eventTypes`}
                    onChange={(value) => {
                                handleFilterUpdate({
                                    eventTypes: {
                                        ...filterInputs.eventTypes,
                                        [value]: !filterInputs.eventTypes[value],
                                    },
                                });
                            }}
                    data-testid={dataTestId && `${dataTestId}.options`}
                />
            </FilterSection>
        </FilterModal>
            )}
    </div>
    );
};

export default EventTypeFilter;
